import {useEffect} from "react";

import {GuideStateApi} from "@repo/guide-state";

/**
 * Sets the prompt (i.e. Guide's `selectedBotName`) on mount with cleanup on
 * unmount
 */
export default function useGuidePrompt(prompt: string | undefined) {
    useEffect(() => {
        const initialPrompt = GuideStateApi.latest().selectedBotName;

        if (prompt) {
            GuideStateApi.set("selectedBotName", prompt);
        }

        return () => {
            // I don't know if this is necessary, but it doesn't hurt
            GuideStateApi.set("selectedBotName", initialPrompt);
        };
    }, [prompt]);
}
